<template>
    <form-container :header="translate('ozneList.eypDefinitions')" v-on:save="save" :disabled="loading">
        <div class="row">
            <div class="col-6">
                <h5>{{ translate('filePreview.oznePreview.ozneInformation:' + ozneKind) }}</h5>
                <div class="form-group">
                    <label>{{translate('ozne.ozneType')}}</label>
                    <select v-model="data.OzneTipi" class="form-control" required>
                        <option value="DAGITIM">{{translate('draftEyp.dagitim')}}</option> 
                        <option value="OLUSTURAN" v-if="!olusturanMevcut">{{translate('filePreview.eypPreview.olusturan')}}</option>
                    </select>
                </div>
                <div class="form-group">
                    <label>Türü</label>
                    <select v-model="data.Kind" @change="changeKind()" class="form-control" required>
                        <option value="KurumKurulus">{{translate('filePreview.oznePreview.ozneKinds.kurumKurulus')}}</option>
                        <option value="TuzelSahis">{{translate('filePreview.oznePreview.ozneKinds.tuzelSahis')}}</option>
                        <option value="GercekSahis">{{translate('filePreview.oznePreview.ozneKinds.gercekSahis')}}</option>
                    </select>
                </div>
                
                <component v-bind:is="data.Kind" v-model="data"></component>
                <div class="form-group">
                    <label>
                        <input type="checkbox" v-model="data.IsActive" />
                        {{translate('ozne.eypReceiverActive')}}
                    </label>
                </div>

            </div>
            <div class="col-6">
                <h5>{{translate('draftEyp.contactDetails')}}</h5>
                <div class="form-group">
                    <label>{{translate('draftEyp.phone')}}</label>
                    <input @input="checkInput('Telefon',$event)" v-model.trim="data.IletisimBilgisi.Telefon" type="tel" class="form-control" />
                </div>
                <div class="form-group">
                    <label>{{translate('draftEyp.phone2')}}</label>
                    <input @input="checkInput('Telefon2',$event)" v-model.trim="data.IletisimBilgisi.Telefon2" type="tel" class="form-control" />
                </div>
                <div class="form-group">
                    <label>{{translate('draftEyp.email')}}</label>
                    <input @input="checkInput('EPosta',$event)" v-model.trim="data.IletisimBilgisi.EPosta" type="email" class="form-control" />
                </div>
                <div class="form-group">
                    <label>{{translate('draftEyp.fax')}}</label>
                    <input @input="checkInput('Faks',$event)" v-model.trim="data.IletisimBilgisi.Faks" type="tel" class="form-control" />
                </div>
                <div class="form-group">
                    <label>{{translate('draftEyp.web')}}</label>
                    <input @input="checkInput('Web',$event)" v-model.trim="data.IletisimBilgisi.Web" type="text" class="form-control" />
                </div>
                <div class="form-group">
                    <label>{{translate('draftEyp.country')}}</label>
                    <input @input="checkInput('Ulke',$event)" v-model.trim="data.IletisimBilgisi.Ulke" type="text" class="form-control" />
                </div>
                <div class="form-group">
                    <label>{{translate('draftEyp.province')}}</label>
                    <input @input="checkInput('Il',$event)" v-model="data.IletisimBilgisi.Il" type="text" class="form-control" />
                </div>
                <div class="form-group">
                    <label>{{translate('draftEyp.district')}}</label>
                    <input @input="checkInput('Ilce',$event)" v-model.trim="data.IletisimBilgisi.Ilce" type="text" class="form-control" />
                </div>
                <div class="form-group">
                    <label>{{translate('draftEyp.address')}}</label>
                    <!-- <textarea v-model="data.IletisimBilgisi.Adres" type="text" maxlength="2000" class="form-control"></textarea> -->
                    <text-area-input v-model="data.IletisimBilgisi.Adres" className="form-control" :maxlength="2000" />
                </div>
            </div>
        </div>
        <template v-slot:footer>
            <div class="row">
                <div class="col">
                    <button type="button" accesskey="g" v-on:click="goBack" class="btn btn-outline-primary">{{translate('goBack')}}</button>
                </div>
                <div class="col text-right">
                    <button type="submit" accesskey="k" class="btn btn-success">{{translate('save')}}</button>
                </div>
            </div>
        </template>
    </form-container>
</template>

<script>
import formMixin from '../formMixin.js';
import formContainer from '../components/FormContainer.vue'
import KurumKurulus from '../components/Ozne/KurumKurulus.vue'
import GercekSahis from '../components/Ozne/GercekSahis.vue'
import TuzelSahis from '../components/Ozne/TuzelSahis.vue'
import TextAreaInput from '@/components/TextAreaInput.vue';
import i18n from '../i18n';


export default {
    mixins: [formMixin],
    components: {
        formContainer,
        KurumKurulus,
        GercekSahis,
        TuzelSahis,
        TextAreaInput
    },
    created(){
        this.getData(this.$route.params.id,this.$route.query.kind)
        .then(() => {
            this.checkOlusturan();
        });
    },
    data() {
        return {
            olusturanMevcut: false, // Daha önce tipi OLUSTURAN olan bir Ozne tanımlanmış mı?
            loading: false,
            modelName: 'Ozne',
            selectedValue: '',
            data: { IletisimBilgisi: {}, OzneTipi:'DAGITIM' },
        }
    },
    computed : {
        ozneKind() {
            const kind = this.data.Kind ? this.data.Kind : null;
            if (kind === 'KurumKurulus') {
            return i18n.t('filePreview.oznePreview.ozneKinds.kurumKurulus');
            } else if (kind === 'GercekSahis') {
            return i18n.t('filePreview.oznePreview.ozneKinds.gercekSahis');
            } else if (kind === 'TuzelSahis') {
            return i18n.t('filePreview.oznePreview.ozneKinds.tuzelSahis');
            }
            
            return kind;
        }
    },
    methods: { 
        changeKind(){
            this.data.IletisimBilgisi={};
            this.data.KurumKimlikKod='';
            this.data.Adi ='';
        },
        checkOlusturan(){
            // OLUSTURAN tipinde sadece bir Özne tanımlanabilir.
            // Eğer bu kayıttan başka OLUSTURAN tipinde bir Ozne
            // var ise OzneTipi alanının seçim listesinden
            // OLUSTURAN seçeneğini kaldırıyoruz.
            
            var predicate = `OzneTipi == "OLUSTURAN" && IsActive=true`;

            if(this.data && this.data.Id) {
                predicate += ` && Id != ObjectId("${this.data.Id}")`;
            }

            this.getOzne({ predicate , take:1 }).then(x => {
                if(x.Result && x.Result.length > 0){
                    this.olusturanMevcut = true;
                    this.data.OzneTipi = 'DAGITIM';
                }
            }).catch(x => {
                console.log("Unvan listesi yüklenemedi:", x);
            });
        
        },
        checkInput(value, event) {
            // Check for invalid characters
            if (/[<>]/.test(event.target.value)) {
                alert(this.translate('errors.invalidSymbols'))
                const editedText = ""
                this.$set(this.data.IletisimBilgisi, value, editedText)
            } else {
                this.$set(this.data.IletisimBilgisi, value, event.target.value)
            }
        },

    }
}
</script>